import React, { useEffect, useState } from 'react';
import { Modal, Card, Button, Spin } from 'antd';
import PropTypes from 'prop-types';
import './StartMCQ.modal.css';
import { ShowMCQList } from '../shared';
import roundCheck from '../../../../assets/img/round-check_circle-24px.svg';
import roundUncheck from '../../../../assets/img/round-uncheck_circle-24px.svg';
import { TestState } from '../constants';

/*
  There is 7 differents cases to show modal:

  1: If current MCQ is passed and it's in top MCQs and there is some MCQ not taken in Top MCQ list:
      modal : You passed the {challengeName} test!
              { MCQListAvailable.length } more to go. Are you ready?
              (button) Not now

  2: If current MCQ is passed and it's in top MCQs and all MCQ in Top MCQ list is taken but not all passed:
      modal : You passed the {challengeName} test!
              (button) Ok

  3: If current MCQ is passed and it's in top MCQs and all MCQ in Top MCQ list is taken and all are passed:
      modal : Congratulations!
              You passed all of your top skills
              Proceed to book your Final
              Live Coding Challenge.
              (button) Take me there
              (button) Not now

  4: If current MCQ is not passed and it's in top MCQs and there is some MCQ not taken in Top MCQ list:
      modal : You didn't pass the {challengeName} test 😔
              Don't worry, you can replace {challengeName} with a different skill
              later. For now, do you want to try your other top skill?
              (button) Not now

  5: If current MCQ is not passed and it's in top MCQs and all MCQ are taken in Top MCQ list:
      modal : You didn't pass the {challengeName} test 😔
              (button) Ok

  6: If current MCQ is passed and it's not in top MCQs:
      modal : You passed the {challengeName} test!
              (button) Ok

  7: If current MCQ is not passed and it's not in top MCQs:
      modal : You didn't pass the {challengeName} test 😔
              (button) Ok
*/

function TakeNextMCQModal (props) {
  const { visible, testsService, MCQList, loading, mcq_use_apiv1 } = props;
  const { closeTakeNextMCQModal } = testsService;
  const { challengeName, passStatus, challengeId } = testsService.props;
  const [nbrLoading, setNbrLoading] = useState(0);
  const currentMCQIsInTopMCQ = !!MCQList.find(mcq => +mcq.challenge_id === +challengeId);

  let MCQListAvailable = [];

  if (mcq_use_apiv1) {
    MCQListAvailable = MCQList.filter(
      item => item.state === TestState.TODO
    ).map(item => {
      item.inTakeNextMCQModal = true;
      return item;
    });
  } else {
    MCQListAvailable = MCQList.filter(
      item => ![1, 2].includes(item.passed) && !item.submit_time
    ).map(item => {
      item.inTakeNextMCQModal = true;
      return item;
    });
  }

  /* CHECK NUMBER OF REQUIRE MCQ - THE SAME NUMBER ON ALL RECORDS BECAUSE OF THE WAY WE RETRIEVE THE LIST */
  const passRequire = MCQList.length ? (MCQList[0].passRequire || MCQList.length) : MCQList.length;
  const allRequire = passRequire >= MCQList.length;
  const fixedMCQ = MCQList.length ? (MCQList[0].isFixedMCQ || 0) : 0;
  const currentFinishingMCQ = MCQList.find(mcq => +mcq.challenge_id === +challengeId);

  let currentFinishingMCQPassed;

  if (mcq_use_apiv1) {
    currentFinishingMCQPassed =
      (currentFinishingMCQ && currentFinishingMCQ.passed) || false;
  } else {
    currentFinishingMCQPassed =
      (currentFinishingMCQ && currentFinishingMCQ.passed === 1) || false;
  }

  let passed = 0;
  
  let bothAllMCQPassed;

  if (mcq_use_apiv1) {
    bothAllMCQPassed = fixedMCQ
      ? MCQList.some(item => {
          if (item.passed) passed++;
          if (passed >= passRequire) return true;
        })
      : !MCQList.some(item => !item.passed);
  } else {
    bothAllMCQPassed = fixedMCQ
      ? MCQList.some(item => {
          if (item.passed === 1) passed++;
          if (passed >= passRequire) return true;
        })
      : !MCQList.some(item => item.passed !== 1);
  }

  useEffect(() => {
    setNbrLoading(nbrLoading + (loading ? 1 : 0));
  }, [loading]);

  const goToLCI = () => testsService.props.history.push('/dashboard/technical_assessment');

  const MCQTestMessage = passStatus && passStatus.passed
    ? (
      <div className="turing-ui-v2-take-next-mcq-modal">
        <img
          src={roundCheck}
          style={{
            width: 64,
            height: 64,
            background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
            opacity: 1
          }}
          alt="check"
        />
        <b>You passed the {challengeName} test!</b>
        { MCQListAvailable.length && currentMCQIsInTopMCQ
          ? (
            <>
              <p>
                { MCQListAvailable.length === 1 ? 'One' : MCQListAvailable.length } more to go. Are you ready?
              </p>
              <ShowMCQList workExpCompleted dataSource={MCQListAvailable} />
            </>
          )
          : null}
        <Button onClick={closeTakeNextMCQModal}>{MCQListAvailable.length && currentMCQIsInTopMCQ ? 'Not now' : 'Ok'}</Button>
      </div>
    )
    : (
      <div className="turing-ui-v2-take-next-mcq-modal">
        <img
          src={roundUncheck}
          style={{
            width: 64,
            height: 64,
            background: `transparent url(${roundUncheck}) 0% 0% no-repeat padding-box !important`,
            opacity: 1
          }}
          alt="check"
        />
        <b>You didn&apos;t pass the {challengeName} test 😔</b>
        {currentMCQIsInTopMCQ
          ? (
            <>
              <p>
            Don&apos;t worry, you can replace {challengeName} with a different skill later. <br/> {MCQListAvailable.length ? 'For now, do you want to try your other top skill?' : null}
              </p>
              <ShowMCQList workExpCompleted dataSource={MCQListAvailable} />
            </>
          )
          : null}
        <Button onClick={closeTakeNextMCQModal}>{MCQListAvailable.length && currentMCQIsInTopMCQ ? 'Not now' : 'Ok'}</Button>
      </div>
    );

  return (
    <Modal
      visible={!!visible && typeof passStatus === 'object' && !loading && nbrLoading > 0}
      onCancel={closeTakeNextMCQModal}
      footer={null}
      width="670px"
      className="turing-ui-v2-mcq-modal"
      bodyStyle={{ padding: 0, margin: 0 }}
      destroyOnClose
      centered
    >
      <div className="turing-ui-v2-start-mcq-modal-container">
        {typeof passStatus === 'object'
          ? (
            <Card className="details-card">
              {((MCQListAvailable.length && !bothAllMCQPassed) || !currentMCQIsInTopMCQ)
                ? (
                  <Spin spinning={loading}>
                    {MCQTestMessage}
                  </Spin>
                )
                : (
                  <Spin spinning={loading}>
                    {(bothAllMCQPassed && currentFinishingMCQPassed)
                      ? (
                        <div className="turing-ui-v2-take-next-mcq-modal">
                          <img
                            src={roundCheck}
                            style={{
                              width: 64,
                              height: 64,
                              background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
                              opacity: 1
                            }}
                            alt="check"
                          />
                          <b>Congratulations!<br/>{allRequire ? 'You passed all of your top skills' : 'You passed all required of your top skills'}</b>
                          <p>
                      Proceed to book your Final<br/> Live Coding Challenge.
                          </p>
                          <Button onClick={goToLCI} type="primary">Take me there</Button>
                          <Button onClick={closeTakeNextMCQModal}>Not now</Button>
                        </div>
                      )
                      : MCQTestMessage}
                  </Spin>
                )}
            </Card>
          )
          : null}

      </div>
    </Modal>
  );
}

TakeNextMCQModal.propTypes = {
  visible: PropTypes.any,
  loading: PropTypes.any,
  MCQList: PropTypes.array,
  allMCQList: PropTypes.array,
  testsService: PropTypes.any,
  mcq_use_apiv1: PropTypes.bool
};

export default TakeNextMCQModal;
